<template>
  <div class="loginStyle">
    <div class="opacityContainer">
      <div class="left_con">
        <div class="center_con">
          <div class="logo_con">
            <img src="../assets/preindexpic.png" alt="" />
          </div>
          <h1>{{ $root.loginTitle }}</h1>
          <h2>水电一体 | 在线支付 | 无人值守</h2>
        </div>
      </div>
      <div class="right_con">
        <div class="loginMain">
          <el-form>
            <h2 class="myTitle">
              <!-- {{ systemTitle }}<span class="myVersion">1.0</span> -->
              欢迎登录
            </h2>
            <el-form-item style="width: 100%">
              <el-input
                v-model="userCode"
                placeholder="账号"
                v-focus
                clearable
                prefix-icon="icon-yonghu iconfont"
                @keyup.enter.native="moveFocus"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%">
              <el-input
                ref="passwordIptRef"
                v-model="password"
                placeholder="密码"
                show-password
                clearable
                prefix-icon="icon-mima iconfont"
                @keyup.enter.native="login"
              ></el-input>
            </el-form-item>

            <el-form-item style="width: 100%">
              <el-button @click="login" style="width: 100%">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.opacityContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  height: 60%;
  box-shadow: 0 0 20px 8px rgba(246, 248, 250, 0.4);
  display: flex;
  .left_con {
    min-width: 500px;
    flex: 1;
    background-color: rgba(1, 21, 48, 0.3);
    position: relative;
    .center_con {
      width: 100%;
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      text-align: center;
      .logo_con {
        margin-bottom: 15px;
      }
      h2 {
        margin: 20px 0;
      }
    }
  }
  .right_con {
    width: 30%;
    min-width: 250px;
    background-color: #fff;
    padding: 20px;
    .loginMain {
      margin-top: 40%;
      width: 100%;
      /deep/ .el-input__prefix {
        left: 10px;
      }
      /deep/ .el-input__inner {
        padding: 0 30px;
        border-radius: 20px !important;
      }
      /deep/ .el-button {
        margin: 15px 0;
        border-radius: 20px !important;
      }
    }
  }
}
.myTitle {
  text-align: center;
  color: #2baad1;
  font-size: 1.5em;
  position: relative;
  margin-bottom: 12%;
}

.myVersion {
  font-size: 0.5em;
  background-color: crimson;
  border-style: solid;
  border-color: crimson;
  border-radius: 8px;
}
.loginStyle {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url('../assets/科技1.png') no-repeat;
  background-size: cover;
  background-position: 100% 100%;
}
</style>

<script>
import md5 from 'js-md5';
import { selectDicValueByDicKey } from '../api/system/systemCustomConfig';
import { login } from '../api/system/basicUser';
import systemConstant from '../constant/systemConstant';
import {
  getToken,
  removeLoginUser,
  removeToken,
  setLoginUser,
  setToken,
} from '../untils/func';
// import Axios from "axios";
export default {
  directives: {
    //注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus();
      },
    },
  },

  data() {
    return {
      userCode: '',
      password: '',
      systemTitle: '',
    };
  },
  watch: {
    $route() {
      this.userCode = '';
      this.password = '';
    },
  },
  components: {},

  async created() {
    // removeJSessionId();
    this.$root.isLogin = false;
    removeToken();
    removeLoginUser();
    // clearCookie();
    this.Axios.defaults.headers['token'] = '';

    await this.getSystemTitle();
  },
  methods: {
    async login() {
      if (this.userCode == '') {
        this.msgError('账号不能为空');
        return;
      }

      if (this.password == '') {
        this.msgError('密码不能为空');
        return;
      }

      const param = {
        userCode: this.userCode,
        password: md5(this.password),
        loginType: '0',
      };
      const response = await login(param).then();
      if (response.statusCode == '1') {
        this.$root.isLogin = true;
        setToken(response.data.token);
        setLoginUser(response.data.loginUserName);
        this.Axios.defaults.headers['myToken'] = getToken();
        this.$router.push('/mainWindow');
      }
    },

    // 获取标题
    async getSystemTitle() {
      const res = await selectDicValueByDicKey(
        systemConstant.SYSTEM_TITLE
      ).then();
      this.systemTitle = res.data;
    },
    // 焦点下移
    moveFocus() {
      this.$refs.passwordIptRef.focus();
    },
  },
  mounted() {},
};
</script>